"use client";
import Image from "next/image";
import styles from "./ScholarshipHeroBanner.module.scss";

const ScholarshipHeroBanner = ({ Banner }: any) => {
  const scrollToSection = () => {
    document.getElementById("scholarship-card")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };
  return (
    <section className={styles.section}>
      <div className={styles.wrapper}>
        <div className={styles.bannerCard}>
          <div className={styles.content}>
            <h1
              className={styles.heading}
              dangerouslySetInnerHTML={{
                __html: Banner?.TitleCk?.replace(/<\/?p>/gi, "") || "",
              }}
            />
            <p className={styles.description}>{Banner?.Description}</p>

            <button
              type="button"
              className={`${styles.ctaButton}`}
              onClick={scrollToSection}
            >
              {Banner?.CTA}
              <Image
                src="https://static-studyabroad.amityonline.com/dev/left_arrow1_6f872732a3.svg"
                alt=""
                width={20}
                height={20}
              />
            </button>
          </div>
          <div className={styles.imageWrapper}>
            <img
              src={Banner?.BgImage?.url}
              alt="Scholarship Banner"
              className={styles.heroImage}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScholarshipHeroBanner;
